// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--O__C3","readOnlyChips":"readOnlyChips--wH9K6"};